import React, { useState } from 'react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Textarea } from '../ui/textarea';
import { CheckCircle2 } from 'lucide-react';

const GOOGLE_FORM_URL =
  'https://docs.google.com/forms/d/e/1FAIpQLSfaX_TgSrcqxYAUHvWH4lw4B9GF5p4rdCxVBtMtO5b7WUIUmQ/viewform?usp=header';

export const FitnessContactForm = () => {
  const [submitted, setSubmitted] = useState(false);
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    experience: '',
    goals: '',
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    window.open(GOOGLE_FORM_URL, '_blank', 'noopener,noreferrer');
    setSubmitted(true);
    setTimeout(() => {
      const el = document.getElementById('fitness-contact');
      if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }, 50);
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  return (
    <section
      id="fitness-contact"
      data-testid="fitness-contact"
      className="bg-black py-14 sm:py-16 lg:py-20 px-6 border-t border-neutral-900"
    >
      <div className="container mx-auto max-w-3xl">
        <div className="text-center mb-10 space-y-4">
          <div className="flex items-center justify-center gap-4">
            <div className="h-px w-16 bg-neutral-700" />
            <p className="text-gray-400 font-bold text-xs tracking-[0.35em] uppercase whitespace-nowrap">
              Get Started
            </p>
            <div className="h-px w-16 bg-neutral-700" />
          </div>
          <h2
            data-testid="fitness-contact-heading"
            className="font-display text-white text-4xl sm:text-5xl lg:text-6xl uppercase leading-none"
          >
            Start Your Fitness Journey.
          </h2>
          <p className="text-gray-400 text-sm sm:text-base max-w-xl mx-auto">
            Tell me a bit about you — I'll follow up with the next steps.
          </p>
        </div>

        {submitted ? (
          <div
            data-testid="fitness-contact-success"
            className="rounded-2xl bg-neutral-950 border border-neutral-800 p-8 sm:p-10 text-center"
          >
            <CheckCircle2 className="w-14 h-14 text-white mx-auto mb-4" strokeWidth={1.5} />
            <h3 className="font-display text-white text-2xl uppercase tracking-wide mb-3">
              Continue Your Application
            </h3>
            <p className="text-gray-300 text-base max-w-md mx-auto mb-6">
              A new tab has opened with the full application form. Please complete it so The Dillon
              Blueprint can follow up with you.
            </p>
            <a
              data-testid="fitness-reopen-google-form"
              href={GOOGLE_FORM_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center justify-center bg-white hover:bg-gray-200 text-black font-bold uppercase tracking-wider text-xs px-6 py-3 rounded-lg transition-colors"
            >
              Open Application Form
            </a>
          </div>
        ) : (
        <form
          onSubmit={handleSubmit}
          data-testid="fitness-contact-form"
          className="space-y-6 bg-neutral-950 rounded-2xl p-6 sm:p-8 border border-neutral-800"
        >
          <div className="grid md:grid-cols-2 gap-6">
            <div className="space-y-2">
              <label className="text-white font-bold text-sm">Full Name *</label>
              <Input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
                data-testid="input-name"
                className="bg-neutral-900 border-neutral-700 text-white focus:border-gray-400 transition-colors"
                placeholder="Your name"
              />
            </div>
            <div className="space-y-2">
              <label className="text-white font-bold text-sm">Email *</label>
              <Input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
                data-testid="input-email"
                className="bg-neutral-900 border-neutral-700 text-white focus:border-gray-400 transition-colors"
                placeholder="you@example.com"
              />
            </div>
          </div>

          <div className="grid md:grid-cols-2 gap-6">
            <div className="space-y-2">
              <label className="text-white font-bold text-sm">Phone</label>
              <Input
                type="tel"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                data-testid="input-phone"
                className="bg-neutral-900 border-neutral-700 text-white focus:border-gray-400 transition-colors"
                placeholder="(555) 555-5555"
              />
            </div>
            <div className="space-y-2">
              <label className="text-white font-bold text-sm">Training Experience</label>
              <Input
                type="text"
                name="experience"
                value={formData.experience}
                onChange={handleChange}
                data-testid="input-experience"
                className="bg-neutral-900 border-neutral-700 text-white focus:border-gray-400 transition-colors"
                placeholder="Beginner / Intermediate / Advanced"
              />
            </div>
          </div>

          <div className="space-y-2">
            <label className="text-white font-bold text-sm">Your Goals</label>
            <Textarea
              name="goals"
              value={formData.goals}
              onChange={handleChange}
              rows={4}
              data-testid="input-goals"
              className="bg-neutral-900 border-neutral-700 text-white focus:border-gray-400 transition-colors"
              placeholder="What do you want to achieve with coaching?"
            />
          </div>

          {/* SMS opt-in consent is collected exclusively via the on-site chat widget for A2P compliance. */}

          <Button
            type="submit"
            data-testid="fitness-contact-submit"
            className="w-full bg-white hover:bg-gray-200 text-black font-bold uppercase tracking-wider text-xs py-6 rounded-lg transition-colors"
          >
            Submit Application
          </Button>
        </form>
        )}
      </div>
    </section>
  );
};
